module.exports = __webpack_public_path__ + "static/media/Drizzle.68e21579.jpg";